import { Injectable } from '@angular/core';
import { AccountTypesInMemoryApiClient } from './account-types.api.inmemory.client';
import { IAccountTypesApiClient } from './i-account-types-api.client';
import { ApiClientProvider } from '../../../../core';
import { AccountTypesApiClient } from './account-types.api.client';

@Injectable({
  providedIn: 'root'
})
export class AccountTypesApiClientProvider extends ApiClientProvider<IAccountTypesApiClient> {
  constructor(
    private client: AccountTypesApiClient,
    private inMemoryClient: AccountTypesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IAccountTypesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IAccountTypesApiClient {
    return this.client;
  }
}
